import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from "@angular/router";
import { RescType } from "@app/models/enums/resc-type.enum";
import { ShowType } from "@app/models/enums/show-type.enum";
import { AuthResource } from "@app/models/settings/auth-resource";
import { BaseComponent } from "@core/component/base/base.component";
import { I18nService } from "@core/services/i18n/i18n.service";
import { getParameterValue, getSearchData, isChangesPropNotEmpty } from "@core/utils";
import { ROUTER_UTILS } from "@core/utils/router.utils";
import { AuthService } from "@services/auth.service";
import { SystemService } from "@services/system.service";
import { cloneDeep, defaults, union } from "lodash";
import { BehaviorSubject, Observable } from "rxjs";

import { CommonModule } from '@angular/common';
import { ThemeChangeComponent } from '@app/components/theme-change/theme-change.component';
import { UserProfileComponent } from '@app/components/user-profile/user-profile.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
@Component({
  standalone: true,
  selector: 'app-sidebar',

  imports: [CommonModule, NzIconModule, NzMenuModule, NzToolTipModule, UserProfileComponent, ThemeChangeComponent],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent extends BaseComponent implements OnInit, OnChanges {

  path = ROUTER_UTILS;
  isLoggedIn$!: Observable<boolean>;
  navList: Array<AuthResource> = [];
  originalNavList: Array<AuthResource> = [];

  @Input() resetNav = false;
  @Input() isCollapsed = false;
  @Output() collapsedEvt = new EventEmitter();

  currEnvVer = new BehaviorSubject<string>('');

  get rescType(): typeof RescType {
    return RescType;
  }

  constructor(
    authService: AuthService,
    i18nService: I18nService,
    private router: Router,
    private systemService: SystemService,
  ) {
    super(authService, i18nService);
  }

  initNavList() {
    this.authService.getAuthRescList().subscribe(res => {
      this.originalNavList = res;
      this.resetNavList();
    });
  }

  resetNavList() {
    this.navList = cloneDeep(this.originalNavList).map(nav => {
      if (this.isInSamePath(nav.path)) {
        if (nav.path?.includes(this.path.business.ecommerce)) {
          const moduleCode = getParameterValue(window.location.search, 'module');
            if (nav.code === moduleCode) {
              nav.isSelected = true;
            }
        }else{
          nav.isSelected = true;
        }
      }
      if (this.hasChildrenNav(nav)) {
        nav.children?.forEach(subNav => {
          if (this.isInSamePath(subNav.path)) {
            subNav.isSelected = true;
            nav.isOpen = true;
          }
        })
      }
      if (nav.path?.includes(this.path.business.ecommerce)) {
        nav['showType'] = ShowType[nav.code as keyof typeof ShowType];
      }
      return nav;
    });
  }

  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isLoggedInSubject;
    this.isLoggedIn$.subscribe(b => {
      if (b) {
        this.initNavList();
      }
    });
    this.systemService.getSysFeatures().subscribe(data => {
      this.currEnvVer.next(data.CUR_ENV_VER);
    });
    this.authService.showModulesSubject.subscribe(showModules => {
      let searchParam = window.location.search;
      if (searchParam) searchParam = decodeURIComponent(searchParam);

      this.navList.forEach(nav => {
        nav.isSelected = false;
        if (nav.path?.includes(this.path.business.ecommerce)) {
          const moduleCode = getParameterValue(searchParam, 'module');
          // nav['children'] = showModules.map((module, idx) => {
          //   module.path = nav.path
            if (nav.code === moduleCode) {
              nav.isSelected = true;
            }
            // return module;
          // })
          // nav.isOpen = true;
        }
      })
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isChangesPropNotEmpty(changes['resetNav']) && this.resetNav) {
      this.resetNavList();
    }
  }


  hasChildrenNav(nav: AuthResource) {
    return (
      nav.type === RescType.ROUTE && nav.children && nav.children.length && nav.children.some(n => n.type === 'ROUTE')
    );
  }

  getChildrenNav(children: AuthResource[]) {
    return children.filter(nav => nav.type === RescType.ROUTE);
  }

  getChildrenAttrCfg(nav: AuthResource) {
    const attrCfg = union(
      nav.children?.filter(ele => ele.type === RescType.ATTR),
      this.navList.filter(ele => ele.type === RescType.ATTR),
    );
    return attrCfg.map(ele => ({[ele.code]: ele.value}));
  }

  isInSamePath(path?: string): boolean {
    return !!path && window.location.pathname.includes(path)
  }

  getTimestamp() {
    return new Date().getTime().toString();
  }
  navMenuClick(nav: AuthResource) {
    if (!nav.path) return;
    if (nav.path.includes(this.path.business.smb)) {
      this.openInNewTab(this.path.business.smb);
      return;
    }
    let routerPath: string[];
    if (nav.showType && this.isInSamePath(nav.path)) {
      routerPath = [];
    } else {
      routerPath = [nav.path];
    }
    const queryParams = defaults({module:nav.code, t:this.getTimestamp()}, getSearchData());
    this.router.navigate(routerPath, { queryParams: nav.showType ? queryParams : null, queryParamsHandling: nav.showType ? 'merge' : null });
  }

  openInNewTab(urlTree: string){
    const route = this.router.serializeUrl(
      this.router.createUrlTree([urlTree]),
    );
    const url = new URL(window.location.href);
    url.search = '';
    const jumpUrl = url.toString().replace(window.location.pathname, '') + route;
    window.open(jumpUrl, '_blank');
  }
}
